var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPromptLogochat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 40,
    viewBox: "0 0 42 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2550_8655)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.53028 24.3778C5.15355 34.5152 15.4273 40.6913 25.4775 38.1729C25.4775 38.1729 35.5851 35.5646 39.6193 37.9898C39.6193 37.9898 37.0851 29.652 38.4754 26.292C39.6773 22.8724 39.9084 19.0562 38.9252 15.2571C36.3019 5.11969 26.0282 -1.05673 15.978 1.46197C5.92778 3.98039 -0.0929866 14.2402 2.53028 24.3778Z",
    fill: "url(#paint0_linear_2550_8655)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.75501 16.187C8.50891 17.7035 8.1163 20.9817 8.6446 24.392C8.66867 24.5479 8.43611 24.6522 8.26281 24.5639L7.26999 24.0568C7.15206 23.9965 7.07564 23.9015 7.0597 23.7954C6.93635 22.9644 6.44505 19.2189 7.18305 16.6685C7.21253 16.5668 7.29647 16.4787 7.41711 16.4266L8.38827 16.007C8.56337 15.9314 8.77908 16.0372 8.75471 16.187H8.75501Z",
    fill: "url(#paint1_linear_2550_8655)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7789 16.1869C33.025 17.7035 33.4177 20.9817 32.8894 24.392C32.8653 24.5479 33.0978 24.6522 33.2711 24.5638L34.264 24.0568C34.3819 23.9965 34.4583 23.9015 34.4743 23.7954C34.5976 22.9644 35.0889 19.2189 34.3509 16.6685C34.3214 16.5668 34.2375 16.4787 34.1168 16.4266L33.1457 16.007C32.9706 15.9314 32.7549 16.0371 32.7792 16.1869H32.7789Z",
    fill: "url(#paint2_linear_2550_8655)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7327 12.024C20.7327 12.024 15.7965 12.0043 12.6857 12.496C12.4733 12.5296 12.3184 12.7073 12.3184 12.9144V13.6287C12.3184 13.8836 12.5497 14.0812 12.8127 14.0497C14.085 13.897 17.5929 13.5136 20.7327 13.5136C23.8724 13.5136 27.3807 13.897 28.6527 14.0497C28.9153 14.0812 29.147 13.8836 29.147 13.6287V12.9144C29.147 12.7073 28.992 12.5296 28.7796 12.496C25.6688 12.0043 20.7327 12.024 20.7327 12.024Z",
    fill: "url(#paint3_linear_2550_8655)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.135 27.4158C23.5376 27.6762 17.9318 27.6762 12.3341 27.4158C10.2378 27.3181 8.53702 25.6121 8.36252 23.4317C8.20728 21.4899 8.20728 19.5375 8.36252 17.5956C8.53702 15.415 10.2378 13.709 12.3341 13.6116C17.9315 13.3511 23.5373 13.3511 29.135 13.6116C31.2314 13.7093 32.9321 15.4153 33.1066 17.5956C33.2619 19.5375 33.2619 21.4899 33.1066 23.4317C32.9321 25.6124 31.2314 27.3184 29.135 27.4158Z",
    fill: "url(#paint4_linear_2550_8655)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M33.1085 17.5959C33.0451 16.8023 32.7788 16.0724 32.3654 15.459C32.4945 17.4423 32.4813 19.4332 32.3227 21.4147C32.1262 23.8683 30.2128 25.7882 27.8538 25.898C21.6947 26.1846 15.5266 26.1904 9.36719 25.9163C10.095 26.793 11.1525 27.3609 12.336 27.416C17.9334 27.6765 23.5393 27.6765 29.137 27.416C31.2333 27.3183 32.934 25.6123 33.1085 23.432C33.2638 21.4901 33.2638 19.5378 33.1085 17.5959Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6662 17.0522H28.8031C29.6148 17.0522 30.274 17.6871 30.274 18.4688V20.6535C30.274 21.4353 29.6148 22.0701 28.8031 22.0701H12.6662C11.8545 22.0701 11.1953 21.4353 11.1953 20.6535V18.4688C11.1953 17.6871 11.8545 17.0522 12.6662 17.0522Z",
    fill: "url(#paint5_linear_2550_8655)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8033 17.5054H12.6664C12.1139 17.5054 11.666 17.9367 11.666 18.4688V20.6535C11.666 21.1856 12.1139 21.6169 12.6664 21.6169H28.8033C29.3558 21.6169 29.8036 21.1856 29.8036 20.6535V18.4688C29.8036 17.9367 29.3558 17.5054 28.8033 17.5054Z",
    fill: "url(#paint6_linear_2550_8655)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3326 19.8757C18.5125 19.4656 18.3132 18.9927 17.8874 18.8194C17.4617 18.6461 16.9706 18.838 16.7907 19.2481C16.6107 19.6582 16.81 20.1311 17.2358 20.3044C17.6616 20.4777 18.1526 20.2858 18.3326 19.8757Z",
    fill: "url(#paint7_linear_2550_8655)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0397 20.3555C24.496 20.2842 24.8058 19.8701 24.7317 19.4307C24.6577 18.9912 24.2278 18.6928 23.7715 18.7642C23.3152 18.8355 23.0054 19.2495 23.0794 19.689C23.1535 20.1284 23.5834 20.4268 24.0397 20.3555Z",
    fill: "url(#paint8_linear_2550_8655)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M12.6664 17.5054C12.114 17.5054 11.666 17.9368 11.666 18.4688V20.6535C11.666 21.1179 12.0072 21.5053 12.4615 21.5966C17.6575 21.4106 22.4086 19.9065 26.1669 17.5057H12.6664V17.5054Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0451 23.8558L20.8045 23.9563C21.0419 23.9866 21.269 24.0061 21.4893 24.006C21.7103 24.007 21.9241 23.9875 22.1448 23.9405C22.3676 23.8963 22.5908 23.8148 22.8535 23.7222C22.7594 23.9755 22.5672 24.1911 22.3211 24.3352C22.0756 24.4808 21.7801 24.5544 21.493 24.5511C21.2045 24.5507 20.9246 24.4815 20.6761 24.364C20.4291 24.2447 20.203 24.083 20.0451 23.8558Z",
    fill: "url(#paint9_linear_2550_8655)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2550_8655",
    x1: 54.581,
    y1: 50.9592,
    x2: -5.80287,
    y2: -5.42504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A2D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D4D80"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2550_8655",
    x1: 6.78532,
    y1: 20.2889,
    x2: 8.75712,
    y2: 20.2889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C3C3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2550_8655",
    x1: 32.7768,
    y1: 20.2889,
    x2: 34.7486,
    y2: 20.2889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C3C3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2550_8655",
    x1: 20.7327,
    y1: 12.0237,
    x2: 20.7327,
    y2: 13.5921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C3C3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2550_8655",
    x1: 20.7346,
    y1: 13.4618,
    x2: 20.7346,
    y2: 27.8046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2550_8655",
    x1: 20.7348,
    y1: 22.1912,
    x2: 20.7348,
    y2: 16.8619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2550_8655",
    x1: 20.735,
    y1: 17.6343,
    x2: 20.735,
    y2: 21.696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C3C3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2550_8655",
    x1: 16.9707,
    y1: 18.9914,
    x2: 18.1095,
    y2: 20.1741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07DFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0199FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2550_8655",
    x1: 23.3128,
    y1: 18.9909,
    x2: 24.4519,
    y2: 20.1737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07DFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0199FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2550_8655",
    x1: 20.9354,
    y1: 24.6716,
    x2: 21.8342,
    y2: 23.0711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C3C3B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2550_8655"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41.2941,
    height: 39,
    fill: "white",
    transform: "translate(0.115234 0.317444)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromptLogochat);
export default __webpack_public_path__ + "static/media/prompt-logochat.6e073c6b5aebfacfb4f982782e615daa.svg";
export { ForwardRef as ReactComponent };